import React from 'react';
import { getPositionsForSport } from '../data/sportsData';

function PositionSelector({ sport, value, onChange, className = '' }) {
  const positions = getPositionsForSport(sport);

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent ${className}`}
    >
      <option value="">Select position...</option>
      {positions.map((position, index) => (
        <option key={index} value={position}>
          {position}
        </option>
      ))}
    </select>
  );
}

export default PositionSelector;